import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import OrdersFilter from './orders/OrdersFilter';
import OrderLines from './orders/OrderLines';
import Orders from './orders/Orders';
import QuotesFilter from './quotes/QuotesFilter';
import QuoteLines from './quotes/QuoteLines';
import Loading from './Loading';
import StatusHelper from '../helpers/StatusHelper';
import DateHelper from '../helpers/DateHelper';
import Notifications from '../services/Notifications';
import { useStateStorageConfig } from '../hooks/StateStorageConfigContext';
import OrderService from '../services/OrderService';
import { withSelectedCustomer } from '../hooks/withSelectedCustomer';
import { withSalesHistoryConfig } from '../hooks/SalesHistoryConfigContext';
import { withStorefrontConfig } from '../hooks/StorefrontSettingsContext';
import NotificationBanner from "./banner/NotificationBanner";
import { useQuotesFilter } from '../hooks/QuotesFilterContext';
import { useOrdersFilter } from '../hooks/OrdersFilterContext';
import {useTheme, useMediaQuery} from '@mui/material';

const getStringDate = (date) => {   
    if (!date) return '';
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) {
        return '';
    } else {
        const year = dateObj.getFullYear().toString();
        const month = ("0" + (dateObj.getMonth() + 1)).slice(-2);
        const day = dateObj.getDate().toString();
        return `${year}-${month}-${day}`;
    }
};

export const OrderHistory = (props) => {
    const ShowOrderHistoryEstimatedShipDate = props.salesHistoryConfig.settings.ShowOrderHistoryEstimatedShipDate;
   
    
    const [pageSize, setPageSize] = useState(50);
    const [hideQuoteFilters, setHideQuoteFilters] = useState(false);
    const [orders, setOrders] = useState(null);
    const [count, setCount] = useState(null);
    const [fetching, setFetching] = useState(false);
    const [customerId, setCustomerId] = useState(null);
    const [fullOrdersList, setFullOrdersList] = useState(null);   
    const [toFullDate, setToFullDate] = useState(new Date());

    //Quotes
    const [quoteStatusFilterOptions, setQuoteStatusFilterOptions] = useState(null);
    const stateStorageConfig = useStateStorageConfig();
    const localized = props.salesHistoryConfig.labels;
    const [loadfromState, SetLoadfromState] = useState(false);    

    const { filters: quotesFilters, updateFilter: updateQuotesFilter, clearFilters: clearQuotesFilter } = useQuotesFilter();
    const { filters: ordersFilters, updateFilter: updateOrdersFilter, clearFilters: clearOrdersFilter } = useOrdersFilter();
    const [sort, setSort] = useState(quotesFilters.sort);

    const activeOrderStatuses = props.location.query ? props.location.query.statuses : (props.isQuote ? quotesFilters.status : ordersFilters.status);
    const activeDateRange = props.location.query ? props.location.query.dateRange : (props.isQuote ? quotesFilters.dateRange : ordersFilters.dateRange);
    const [dateRange, setDateRange] = useState(activeDateRange);
    const [status, setStatus] = useState(activeOrderStatuses);

    const [page, setPage] = useState(() =>
        props.isQuote ? quotesFilters.page : ordersFilters.page
    );
    const [number, setNumber] = useState(() =>
        props.isQuote ? quotesFilters.numberFilter : ordersFilters.numberFilter
    );
    const [toDate, setToDate] = useState(() =>
        props.isQuote ? getStringDate(quotesFilters.toFullDate) : getStringDate(ordersFilters.toFullDate)
    ); 
    const [fromDate, setFromDate] = useState(getStringDate(new Date().setDate(new Date().getDate() - activeDateRange)));
    const [fromFullDate, setFromFullDate] = useState(new Date().setDate(new Date().getDate() - activeDateRange));
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const theme = useTheme();
    const pendingRefetch = React.useRef(false);
    const isListView = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });

    useEffect(() => {
        setDateRange(quotesFilters.dateRange);
        setStatus(quotesFilters.status);
        setNumber(quotesFilters.numberFilter);
        setSort(quotesFilters.sort);
        setFromDate(getStringDate(quotesFilters.fromFullDate));
        setToDate(getStringDate(quotesFilters.toFullDate));
    }, [quotesFilters]);

    useEffect(() => {
        setDateRange(ordersFilters.dateRange);
        setStatus(ordersFilters.status);
        setNumber(ordersFilters.numberFilter);
        setFromDate(getStringDate(ordersFilters.fromFullDate));
        setToDate(getStringDate(ordersFilters.toFullDate));
    }, [ordersFilters]);
    

    useEffect(() => {
        if (props.isQuote) {
            updateQuotesFilter('fromDate', fromDate);
        } else {
            updateOrdersFilter('fromDate', fromDate);
        }
    }, [fromDate]);

    useEffect(() => {
        if (props.isQuote) {
            updateQuotesFilter('fromFullDate', fromFullDate);
        } else {
            updateOrdersFilter('fromFullDate', fromFullDate);
        }
    }, [fromFullDate]);

    useEffect(() => {
        const custId = props && props.selectedCustomer ? props.selectedCustomer.id : null;
        if (!custId) {
            props.history.push({ pathname: '/' });
        }
    }, [customerId]);

    useEffect(() => {
        if (props && props.selectedCustomer && customerId !== props.selectedCustomer.id) {
            setCustomerId(props.selectedCustomer.id);
            updateOrders();
        }
        setPageSize(50);
    }, [props.selectedCustomer]);

    const updateStateHistoryFilters = (data) => {
        stateStorageConfig.setHistoryFilters(data);
    };


    useEffect(() => {        
        if (fetching) {
              pendingRefetch.current = true;
            } else {
              updateOrders();
            }
    }, [pageSize, status, fromDate, toDate, number, paginationModel]);


    useEffect(() => {

        if (!fetching && loadfromState) {0
.            updateOrders();

            SetLoadfromState(false);
        }
    }, [loadfromState, fetching]);
   
    //Order Screen filters functions
    const updateFilterStatus = (e) => {
        let status = [];
        if (props.salesHistoryConfig.settings.OrdersByLine == true || props.salesHistoryConfig.settings.ShowOrderStatus == true) {
            e.forEach((x) => {
                status.push(x.value)
            });
        } else {
            status = [];
        }
        updateStateHistoryFilters({ status: status });
        setStatus(status);
        setPaginationModel(pm => ({ ...pm, page: 0 }))
    };

    const updateFilterSortQuotes = (e) => {
        setSort(e.value);
        setPaginationModel(pm => ({ ...pm, page: 0 }))
    };

    const updateFilterStatusQuotes = (e) => {
        let status = [];
        if (props.salesHistoryConfig.settings.OrdersByLine == true) {
            e.forEach((x) => {
                status.push(x.value)
            });
        } else {
            status = [];
        }
        updateStateHistoryFilters({ status: status });
        setStatus(status);
        setPaginationModel(pm => ({ ...pm, page: 0 }))

    };

    const updateFilterFromDate = (e) => {
        const currentDate = new Date();
        const toDate = toFullDate;
        // From Date can't be in the future
        var futureFromDateResult = DateHelper.compareDates(e, currentDate);
        // From Date must be less than to date
        var result = DateHelper.compareDates(e, toDate);
        if (futureFromDateResult == 1) {
            return Notifications.error(localized.FromDateFutureError);
        } else if (result == 1) {
            return Notifications.error(localized.FromDateToDateError);
        } else {
            updateStateHistoryFilters({ fromDate: getStringDate(e) });
            updateStateHistoryFilters({ fromFullDate: e });
            setFromFullDate(e);
            setFromDate(getStringDate(e)); // passing only date no time due to timezone
            setPaginationModel(pm => ({ ...pm, page: 0 }))
        }
    };

    const updateFilterToDate = (e) => {
        // To Date must be greater than from date
        const parseToDate = Date.parse(e);
        const parseFromDate = Date.parse(fromDate);
        if (parseToDate < parseFromDate) {
            return Notifications.error(localized.ToDateError);
        }

        updateStateHistoryFilters({ toDate: getStringDate(e) });
        updateStateHistoryFilters({ toFullDate: e });
        setToFullDate(e);
        setToDate(getStringDate(e)); // passing only date no time due to timezone
        setPaginationModel(pm => ({ ...pm, page: 0 }))
    };

    const updateFilterSearchNumber = (e) => {
        updateStateHistoryFilters({ number: e.target.value });
        setNumber(e.target.value);
        setPaginationModel(pm => ({ ...pm, page: 0 }))
    };

    const resetOrdersFilters = () => {
        stateStorageConfig.resetHistoryFilters();
        clearOrdersFilter();
        setPaginationModel(pm => ({ ...pm, page: 0 }))
    };


    useEffect(() => {       
        if (fetching) {
              pendingRefetch.current = true;
            } else {
              updateOrders();
            }
    }, [sort]);

    useEffect(() => {
        if (orders && orders.length > 0 && props.isQuote && !fetching) {
            loadedOrders(orders);
        }
    }, [orders]);

    useEffect(() => {
        if (!fetching && pendingRefetch.current) {
            pendingRefetch.current = false;
            updateOrders();
        }
    }, [fetching]);

    const resetQuotesFilters = () => {
        stateStorageConfig.resetHistoryFilters();        
        clearQuotesFilter();
        setPaginationModel(pm => ({ ...pm, page: 0 }))
    };
    //This function is use to load Status filter in Quote filters
    const loadedOrders = (data) => {
        if (data) {
            var statusResult = [];
            const key = props.isQuote ? 'quoteStatus' : 'status';
            const filterStatus = [...new Map(data?.map(item => [item[key], item])).values()];
            filterStatus.forEach((o) => {
                statusResult.push({ value: o[key], label: StatusHelper.formatQuoteStatus(o[key], localized) });
            });
            setQuoteStatusFilterOptions(statusResult);
        }
    };
    const updateFilterFromDateQuote = (e) => {
        const currentDate = new Date();
        const toDate = toFullDate;
        // From Date can't be in the future
        var futureFromDateResult = DateHelper.compareDates(e, currentDate);
        // From Date must be less than to date
        var result = DateHelper.compareDates(e, toDate);
        if (futureFromDateResult == 1) {
            return Notifications.error(localized.FromDateFutureError);
        } else if (result == 1) {
            return Notifications.error(localized.FromDateToDateError);
        } else {
            updateStateHistoryFilters({ fromDate: getStringDate(e) });
            updateStateHistoryFilters({ fromFullDate: e });
            setFromFullDate(e);
            setFromDate(getStringDate(e)); // passing only date no time due to timezone
            setPaginationModel(pm => ({ ...pm, page: 0 }))
        }
    };
    const showHideQuotesFilter = (hide) => {
        setHideQuoteFilters(hide);
    };

    const updateOrders = () => {
        fetchOrders();
        getFullOrdersList();
    };

    const pageCount = () => {
        return Math.ceil(count / pageSize);
    };

    const updateIsFetching = (newFetching) => {
        setFetching(newFetching);
    };

    const fetchOrders = () => {
        if (props.selectedCustomer) {
            setFetching(true);
            let state = {
                number,
                pageSize: paginationModel.pageSize,
                page: paginationModel.page,
                dateRange,
                sort,
                fromDate,
                toDate,
                status
            };

            return OrderService.fetchOrders(state, props, false)
                .then((data) => {
                    if (data) {                        
                        setOrders(data.orders);
                        setCount(data.totalCount);
                        setFetching(false);
                    }
                });
        }
    };

    const getFullOrdersList = () => {
        setFetching(true);
        let state = {
            number,
            pageSize: paginationModel.pageSize,
            page: paginationModel.page,
            dateRange,
            sort,
            fromDate,
            toDate,
            status
        };

        if (!props.isQuote) {
            return OrderService.fetchOrders(state, props, true)
                .then((data) => {
                    if (data) {
                        setFullOrdersList(data.orders);
                        setFetching(false);
                    }
                });
        }
    };

    const renderOrderFilter = () => {
        return (
            <OrdersFilter
                fromFullDate={fromFullDate}
                toFullDate={toFullDate}
                totalCount={count}
                paginationModel={paginationModel}
                setPaginationModel={setPaginationModel}
                rowsPerPageOptions={[10, 25, 50, 100]}
                setFromDate={updateFilterFromDate}
                setToDate={updateFilterToDate}
                setStatus={updateFilterStatus}
                setNumber={updateFilterSearchNumber}
                listView={isListView}
                fetchOrders={updateOrders}
                resetFilters={resetOrdersFilters}
                historyByLine={props.salesHistoryConfig.settings.OrdersByLine === true}
                localized={props.salesHistoryConfig.labels}
                dateFormat={props.StorefrontConfig.settingsList.DateFormat}
                availableStatuses={props.StorefrontConfig.storefrontOrderQuoteStatuses}
            />
        );
    };

    const renderQuoteFilter = () => {
        return (
            <div id="quotes-filter-container">
                <QuotesFilter
                    fromFullDate={fromFullDate}
                    toFullDate={toFullDate}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    maxFromDate={props.StorefrontConfig.settingsList.QuoteHistoryMax}
                    listView={isListView}
                    setFromDate={updateFilterFromDateQuote}
                    setToDate={updateFilterToDate}
                    setSort={updateFilterSortQuotes}
                    setStatus={updateFilterStatusQuotes}
                    setNumber={updateFilterSearchNumber}
                    totalCount={count}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    fetchOrders={fetchOrders}
                    resetFilters={resetQuotesFilters}
                    localized={props.salesHistoryConfig.labels}
                    availableStatuses={props.StorefrontConfig.storefrontOrderQuoteStatuses}
                    dateFormat={props.StorefrontConfig.settingsList.DateFormat}
                />
            </div>
        );
    };

    const renderOrdersByLine = () => {

        return (
            <div>        
                {renderOrderFilter() }
                <OrderLines
                    selectedCustomer={props.selectedCustomer}
                    currentUser={props.currentUser}
                    orderLines={orders}
                    count={count}
                    fetching={fetching}
                    ordersByLinePDF={props.salesHistoryConfig.settings.OrdersByLinePDF === true}
                    shareViaWhatsApp={props.salesHistoryConfig.settings.ShareViaWhatsApp === true}
                    csvOrders={fullOrdersList}
                    localized={props.salesHistoryConfig.labels}
                    dateDisplayFormat={props.StorefrontConfig.settingsList.DateDisplayFormat}
                    showEstimatedShipDate={ShowOrderHistoryEstimatedShipDate}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    listView={isListView}
                />
            </div>
        );
    };

    const renderOrderHeaders = () => {
        return (
            <div>
                {renderOrderFilter()}
                <Orders
                    listView={isListView}
                    orders={orders}
                    fetching={fetching}
                    localized={props.salesHistoryConfig.labels}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    count={count }
                />
            </div>
        );
    };

    const renderQuotesHeaders = () => {
        return (
            <div>
                {!hideQuoteFilters && renderQuoteFilter()}
                <QuoteLines
                    selectedCustomer={props.selectedCustomer}
                    currentUser={props.currentUser}
                    quotes={orders}
                    fetching={fetching}
                    hideQuotesFilter={showHideQuotesFilter}
                    downloadQuotePDF={props.salesHistoryConfig.settings.DownloadQuotePDF === true}
                    editQuoteEnabled={props.salesHistoryConfig.settings.EditQuoteEnabled === true}
                    convertQuoteEnabled={props.salesHistoryConfig.settings.ConvertQuoteEnabled === true}
                    rejectQuoteEnabled={props.salesHistoryConfig.settings.RejectQuoteEnabled === true}
                    fetchOrders={fetchOrders}
                    count={count}
                    setFetching={updateIsFetching}
                    localized={props.salesHistoryConfig.labels}
                    dateFormat={props.StorefrontConfig.settingsList.DateFormat}
                    storefrontConfig={props.StorefrontConfig}
                    paginationModel={paginationModel}
                    setPaginationModel={setPaginationModel}
                    listView={isListView}
                    />
            </div>
        );
    };

    const ordersByLine = (props.salesHistoryConfig.settings.OrdersByLine === true);
    const { isQuote, selectedCustomer } = props;

    return (
        <React.Fragment>
            {!props.salesHistoryConfig.salesHistoryConfigLoaded &&
                <Loading type="brand" />
            }
            {selectedCustomer && props.salesHistoryConfig.salesHistoryConfigLoaded &&
                <React.Fragment>
                    <NotificationBanner
                        classOverride="mb-4"
                        locale={props.StorefrontConfig.locale}
                        page={props.isQuote ? "QuoteHistory" : "OrderHistory"}
                    />

                    {isQuote &&
                        renderQuotesHeaders()
                    }
                    {!isQuote && ordersByLine &&
                        renderOrdersByLine()
                    }
                    {!isQuote && !ordersByLine &&
                        renderOrderHeaders()
                    }
                </React.Fragment>
            }
        </React.Fragment>
    );
};

OrderHistory.propTypes = {
    selectedCustomer: PropTypes.object,
    currentUser: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        selectedCustomer: state.user.selectedCustomer,
        currentUser: state.user.currentUser

    };
}

export default connect(
    mapStateToProps, null
)(withRouter(withSalesHistoryConfig(withStorefrontConfig(withSelectedCustomer(OrderHistory)))));
